/** Default customer site upload cap. 256 MiB covers a WordPress archive. */
export const DEFAULT_SITE_UPLOAD_MAX_BYTES = 256 * 1024 * 1024;

/** Hard ceiling for SITES_UPLOAD_MAX_BYTES. */
export const MAX_SITE_UPLOAD_MAX_BYTES = 1024 * 1024 * 1024;

/** A normal WordPress tree is a few thousand files. This leaves room for plugins. */
export const DEFAULT_SITE_ZIP_MAX_ENTRIES = 20_000;

/** Uncompressed ceiling for one archive, separate from the compressed upload cap. */
export const DEFAULT_SITE_ZIP_MAX_UNCOMPRESSED_BYTES = 1024 * 1024 * 1024;

export function siteUploadLimitLabel(bytes: number): string {
	const mb = bytes / (1024 * 1024);
	if (mb >= 1 && Number.isInteger(mb)) return `${mb} MB`;
	if (mb >= 1) return `${(Math.round(mb * 10) / 10).toFixed(1)} MB`;
	if (bytes >= 1024 && bytes % 1024 === 0) return `${bytes / 1024} KB`;
	return `${bytes} bytes`;
}

export function siteUploadTooLargeMessage(maxBytes: number): string {
	return `That file is larger than ${siteUploadLimitLabel(maxBytes)}.`;
}
